/**
 * De kleine dingen die de browser voor het rapportscherm doet: iets naar het
 * klembord zetten, en een PDF aanbieden — om te bewaren of om te bekijken.
 */

/** `true` als het klembord de tekst aannam. */
export async function copyText(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);

        return true;
    } catch {
        return false;
    }
}

/**
 * Biedt een bestand aan als download. De PDF komt met de sessie binnen, dus een
 * gewone link naar de API werkt hier niet.
 */
export function offerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    document.body.append(link);
    link.click();
    link.remove();

    /* Even laten staan: sommige browsers lezen het bestand pas na de klik. */
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * Opent de PDF in een nieuw tabblad, om hem eerst te bekijken.
 *
 * `false` als de browser het tabblad tegenhield (pop-upblokkering); het scherm
 * biedt dan downloaden aan, zodat er nooit een knop is die niets doet.
 */
export function openInNewTab(blob: Blob): boolean {
    const url = URL.createObjectURL(blob);
    const opened = window.open(url, '_blank', 'noopener');

    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);

    return opened !== null;
}
